'use client';

import theme from '@/components/core/theme';
import { css } from '@linaria/core';

export const root = css`
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 1rem;
  padding-top: 1rem;
  align-self: normal;
  @media screen and (width > ${theme.sizes.screens.md}) {
    padding-top: 4rem;
  }

  h1 {
    text-align: center;
    font-size: 34px;
    font-style: normal;
    font-weight: 700;
    line-height: 1.1;
    @media screen and (width > ${theme.sizes.screens.md}) {
      font-size: 48px;
    }
  }
`;

export const searchCategorySelector = css`
  margin: 0 calc(var(--screen-padding) * -1);
  align-self: stretch;

  @media screen and (width > ${theme.sizes.screens.lg}) {
    && {
      display: flex;
      justify-content: center;
    }
  }
`;

export const scrollContent = css`
  padding: 0 var(--screen-padding);
  display: inline-flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 1.25rem;
  min-width: max-content;
  margin: auto;
`;

export const omnisearch = css`
  flex-grow: 0;
  color: ${theme.colors.primary[1]};
`;

export const categoryTab = css`
  display: flex;
  flex-shrink: 0;
  gap: 0.25rem;
  align-items: flex-end;
  img {
    height: 30px;
  }
  &:hover {
    color: ${theme.colors.primary[1]};
  }
`;

export const search = css`
  --control-height: 50px;
  width: 100%;
  max-width: 700px;
`;
